export default "__VITE_ASSET__Caa2seZb__"